import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-560231c8")

_pushScopeId("data-v-560231c8")
const _hoisted_1 = {
  role: "form",
  class: "form"
}
const _hoisted_2 = { class: "inputContainer" }
const _hoisted_3 = { class: "errorText" }
const _hoisted_4 = { class: "inputContainer" }
const _hoisted_5 = { class: "errorText" }
const _hoisted_6 = { class: "inputContainer" }
const _hoisted_7 = { class: "errorText" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        type: "text",
        class: {error: _ctx.nameHasError},
        placeholder: "Full Name",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullName = $event))
      }, null, 2), [
        [_vModelText, _ctx.fullName]
      ]),
      _withDirectives(_createVNode("p", _hoisted_3, "Please enter your full name", 512), [
        [_vShow, _ctx.nameHasError]
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _withDirectives(_createVNode("input", {
        type: "text",
        class: {error: _ctx.emailHasError},
        placeholder: "Email",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event))
      }, null, 2), [
        [_vModelText, _ctx.email]
      ]),
      _withDirectives(_createVNode("p", _hoisted_5, "Please enter a valid email", 512), [
        [_vShow, _ctx.emailHasError]
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _withDirectives(_createVNode("textarea", {
        type: "text",
        class: {error: _ctx.messageHasError},
        placeholder: "Message",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.message = $event))
      }, null, 2), [
        [_vModelText, _ctx.message]
      ]),
      _withDirectives(_createVNode("p", _hoisted_7, "Please enter a message", 512), [
        [_vShow, _ctx.messageHasError]
      ])
    ]),
    _createVNode(_component_Button, {
      type: "button",
      disabled: _ctx.isMessageSending,
      color: "primary",
      click: _ctx.sendMessage
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.isMessageSending ? 'SENDING...' : 'SEND'), 1)
      ]),
      _: 1
    }, 8, ["disabled", "click"]),
    _withDirectives(_createVNode("h3", null, " Message sent! Redirecting back to Home in " + _toDisplayString(_ctx.rerouteCountdown) + "... ", 513), [
      [_vShow, _ctx.isSuccessfulSend]
    ]),
    _withDirectives(_createVNode("h3", null, _toDisplayString(_ctx.errorMessage), 513), [
      [_vShow, Boolean(_ctx.errorMessage)]
    ])
  ]))
})